import React, { useState } from 'react';
import { Button, Header, Input } from '../../components';
import Loading from '../../components/Loading';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useStateContext } from '../../contexts/ContextProvider';
import Select from 'react-select';
import axiosClient from '../../axios-client';
import Alert from '../../components/Alert';
import { toast } from 'react-toastify';
import SelectMulti from '../../components/SelectMulti';
import { IoIosSave } from 'react-icons/io';
import { GiCancel } from 'react-icons/gi';

const AddFacture = ({ isVisible, onClose, inscription, mensualite }) => {
    const [loading, setLoading] = useState(false);
    const [moisScolaires, setMoisScolaires] = useState([]);
    const [selected, setSelected] = useState([]);
    const { token, setToken } = useStateContext();
    const [errors, setErrors] = useState(null);
    const [facture, setFacture] = useState({
        'id': '',
        'frais': 0,
        'uniforme': 0,
        'mois': selected,
        'restaurant': 0,
        'paiement': 0,
        'dispense': 0,
        'total': 0,
        'inscription': inscription,

    })
    useEffect(() => {
        getMois();
    }, []);
    useEffect(() => {
        var tot = parseFloat(selected.length * mensualite) + parseFloat(facture.frais) + parseFloat(facture.uniforme) + parseFloat(facture.restaurant) - parseFloat(facture.dispense);
        setFacture({ ...facture, mois: selected, total: tot });
    }, [selected]);
    useEffect(() => {
        let tot = parseFloat(selected.length * mensualite) + parseFloat(facture.frais) + parseFloat(facture.uniforme) + parseFloat(facture.restaurant) - parseFloat(facture.dispense);
        setFacture({ ...facture, total: tot });
        
    }, [facture.frais, facture.dispense, facture.uniforme, facture.restaurant]);
    const getMois = () => {
        axiosClient.get('/mois-scolaires')
            .then((data) => {
                setMoisScolaires(data.data.mois);
                setLoading(false);
            })
    }
    const navigate = useNavigate();

    const onSubmit = () => {

        setErrors(null);
        setLoading(true);

        axiosClient.post('/facture/save', facture)
            .then((response) => {
                setLoading(false);
                setErrors(null);
                onClose();
            }).catch(err => {
                const response = err.response;
                if (response.status === 401) {
                    setToken(null);
                }
                else {
                    if (response.status === 422) {
                        setErrors(response.data.errors);
                        setLoading(false);
                        toast.error('Merci de verifier les informations a saisies!', {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: true,
                            draggable: true,
                            progress: undefined,
                            theme: "light",
                        });
                    } else {
                        if (response.status === 403) {
                            navigate('/403');
                        } else {
                            if (response.status === 404) {
                                navigate('/404');
                            }
                            else {
                                navigate('/500');
                            }
                        }
                    }

                }
            })
    }
    if (!isVisible) {
        return null
    }

    return (
        <>
            <div className=' fixed inset-0 h-full bg-black bg-opacity-25 backdrop-blur-sm  '>
                <div className='h-screen flex justify-center items-center'>
                    <div className='flex-col bg-white lg:p-10 xl:p-10  p-2 md:p-10 w-auto rounded-xl'>
                        <div className=''>
                            <Header title="Ajouter une Facture" />
                        </div>
                        {errors &&
                            Object.keys(errors).map(key => (
                                <Alert key={key} message={errors[key][0]} />
                            ))
                        }
                        {loading ? <Loading /> :
                            <div className='flex'>
                                <div className='flex-col justify-evenly '>
                                    <div className='mr-2'>
                                        <Input label="Frais" type="number" value={facture.frais} onChange={ev => setFacture({ ...facture, frais: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Uniforme" type="number" value={facture.uniforme} onChange={ev => setFacture({ ...facture, uniforme: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Restaurant" type="number" value={facture.restaurant} onChange={ev => setFacture({ ...facture, restaurant: ev.target.value })} required="required" />
                                    </div>
                                    <div className='flex flex-wrap md:flex-nowrap lg:flex-nowrap xl:flex-nowrap w-full   mt-6'>
                                        <SelectMulti label="Mois" selected={selected} setSelected={setSelected} options={moisScolaires} required="required" />
                                    </div>

                                </div>
                                <div className='flex-col justify-evenly '>
                                    <div className='mr-2'>
                                        <Input label="Dispense" type="number" value={facture.dispense} onChange={ev => setFacture({ ...facture, dispense: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Net à payer" type="number" value={facture.total} onChange={ev => setFacture({ ...facture, uniforme: ev.target.value })} required="required" />
                                    </div>
                                    <div className='mr-2'>
                                        <Input label="Payée" type="number" value={facture.paiement} onChange={ev => setFacture({ ...facture, paiement: ev.target.value })} required="required" />
                                    </div>


                                </div>
                            </div>
                        }
                        <div className='flex justify-end items-end'>
                            <div className='flex m-4 gap-3 justify-between'>
                                <Button icon={<IoIosSave />} onClick={onSubmit} color="ml-1 bg-green-500" textColor="text-white" text="Enregistrer" />
                                <Button icon={<GiCancel />} onClick={() => onClose()} color="bg-red-500" textColor="text-white" text="Fermer" />

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </>

    )
}

export default AddFacture